import { createTheme } from '@mui/material/styles';

export const getHRTheme = (mode) =>
  createTheme({
    palette: {
      mode,

      ...(mode === 'light'
        ? {
            background: {
              default: '#f1f5f9',
              paper: '#ffffff'
            },
            primary: {
              main: '#2563eb'
            },
            text: {
              primary: '#0f172a',
              secondary: '#475569'
            }
          }
        : {
            background: {
              default: '#0f172a',
              paper: '#111827'
            },
            primary: {
              main: '#3b82f6'
            },
            text: {
              primary: '#e5e7eb',
              secondary: '#9ca3af'
            },
            divider: '#1f2933'
          })
    },

    shape: {
      borderRadius: 14
    },

    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none'
          }
        }
      },

      MuiCard: {
        styleOverrides: {
          root: ({ theme }) => ({
            backgroundColor: theme.palette.background.paper,
            boxShadow:
              theme.palette.mode === 'dark'
                ? '0 8px 30px rgba(0,0,0,0.6)'
                : '0 8px 24px rgba(0,0,0,0.08)'
          })
        }
      },

      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontWeight: 700
          }
        }
      }
    },

    typography: {
      fontFamily: `'Inter', 'Roboto', sans-serif`
    }
  });
